import React from "react";
import { CrossThin } from "../../constants/svg";
import { Assets } from "../../constants/images";
import AvatarImage from "./AvatarImage";

const ResponsesToolTip = ({
  hide,
  toolTipData,
  greenBG,
  redBG,
  surveyData,
  toolTipTitle = "Responses",
}) => {
  // const handleClose = () => {
  //   setIsApply(false)
  //   setIsApplyCorrect(false)
  //   closeToolTip({ open: false, id: null });
  //   setIsOpen(false)
  // };

  return (
    <>
      <div className="customToolTipBox">
        {/* <div className="triangleToolTip">
          <ToolTipTriangle />
        </div> */}
        <div
          className={
            greenBG
              ? "header d-flex align-items-center justify-content-between greenheader"
              : redBG
                ? "header d-flex align-items-center justify-content-between redheader"
                : "header blueheader d-flex align-items-center justify-content-between"
          }
        >
          <h5 className="white m-0 p-0">{toolTipTitle}</h5>
          <div className="icon cursor-pointer" onClick={hide}>
            <CrossThin />
          </div>
        </div>
        <div className="body">
          <ul>
            {toolTipData.map((data, index) => {
              const isAnonymous = surveyData?.anonymous_response === 10;
              return (
                <li key={index}>
                  <div
                    style={{
                      width: "26px",
                      height: "26px",
                    }}
                  >
                    <AvatarImage
                      name={
                        isAnonymous
                          ? "Anonymous User"
                          : data?.name || "App User"
                      }
                      src={isAnonymous ? null : data?.avatar}
                      placeholder={Assets.ProfilePlaceholder}
                      size={26}
                    />
                  </div>
                  <p
                    className={`m-0 black ${isAnonymous ? "anonymous-user-name" : ""}`}
                  >
                    {isAnonymous
                      ? "Anonymous User"
                      : data?.name
                        ? data?.name
                        : "App User"}
                  </p>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ResponsesToolTip;
